import { atom } from 'recoil';

export const isNewGreaseTrapModalOpenAtom = atom<boolean>({
  key: 'isNewGreaseTrapModalOpenState',
  default: false,
});
